import request from '@utils/axiosWrapper';
import * as Ids from '@utils/ids';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';

export interface AuditResult {
    auditDate: string;
    auditName: string;
    auditStatus: number;
    tips: string;
    isShow: boolean;
}
export const getAuditResult = (): Promise<AuditResult> => {
    return request.get<AuditResult>('/gw/api/audit/majorDispute/getNotice', {
        params: {
            wmPoiId: Ids.getWmPoiId(),
        },
    });
};
export const getMajorDisputeAuditGray = () => {
    return getGrayStateByToken(GRAY_AB_TOKEN.MAJOR_DISPUTE_AUDIT_GRAY_KEY);
};
